import { keepPreviousData, useQuery } from '@tanstack/react-query';

export type Admin = {
  registrantid: string;
  fname: string | null;
  lname: string | null;
  iselevated: boolean;
  isglobal: boolean;
};

export type AdminType = 'global' | 'group' | 'location' | 'unit' | 'registrant';

interface AdminQueryParams {
  type: AdminType;
  searchQuery?: string;
  page?: number;
  limit?: number;
  locationId?: string;
  groupId?: string;
  unitId?: string;
}

const getAdmins = async ({
  type,
  searchQuery = '',
  page = 1,
  limit = 5,
}: AdminQueryParams): Promise<{ admins: Admin[]; totalPages: number }> => {
  const params = new URLSearchParams({
    type,
    q: searchQuery,
    page: page.toString(),
    limit: limit.toString(),
  });

  const response = await fetch(`/api/registrants/admins?${params.toString()}`);

  if (!response.ok) {
    throw new Error(`Failed to fetch ${type} admins`);
  }

  return response.json();
};

export const ADMINS_QUERY_KEY = 'admins';

export const useAdmins = ({ type, searchQuery, page = 1, limit = 5 }: AdminQueryParams) =>
  useQuery({
    queryKey: [ADMINS_QUERY_KEY, type, searchQuery, page, limit],
    queryFn: () =>
      getAdmins({
        type,
        searchQuery,
        page,
        limit,
      }),
    placeholderData: keepPreviousData,
  });
